<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="8" sm="10">
        <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.payments') }}</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <payments-list></payments-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PaymentsList from '../../components/PurchaseOrders/payments/PaymentsList'

export default {
  name: 'PaymentsPage',
  components: { PaymentsList }
}
</script>

<style>

</style>
